import { BaseItemStore } from "../../../core/BaseStore";
import type { BusinessCustomerModel } from "./BusinessCustomerModel";

export default class BusinessCustomersStore extends BaseItemStore<BusinessCustomerModel> {}
